// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 961px)' )
	const breakpointLarge = window.matchMedia( 'screen and (min-width: 1200px)' )
	const breakpointLaptop = window.matchMedia( 'screen and (min-width: 1280px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}


	// header
	// --------------------------------------------------------------- //

	let startPos = 0;
	let header = document.getElementById('js-header');
	let triggerPos = 50;

	// init
	let scrollTop = window.pageYOffset

	if ( scrollTop < triggerPos ) {
		header.classList.remove('is-hidden')
		header.classList.remove('has-animation')
	} else {
		header.classList.add('has-animation')
	}


	window.addEventListener('scroll', function(e) {
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		let currentPos = scrollTop;

		if (currentPos > startPos) {
			// down
			headerRest()
			if ( scrollTop >= triggerPos ) {
				header.classList.add('is-hidden')
				header.classList.add('has-animation')
			}
		} else {
			// up
			header.classList.remove('is-hidden')
			if ( scrollTop < triggerPos ) {
				header.classList.remove('has-animation')
			} else {
				header.classList.add('has-animation')
			}
		}
		startPos = currentPos;
	});

	function headerRest() {
		let headerDropDownTargets = document.querySelectorAll('.js-dropdown')
		let headerBgBody = document.querySelector('body');

		bgBody.classList.remove('is-dropdown-open')

		for ( let i = 0; i < headerDropDownTargets.length; i++) {
			let parent = headerDropDownTargets[i].closest('.has-dropdown')
			parent.classList.remove('is-active')
		}

		// lang switcher
		langContents.style.height = '0px'
		langTarget.classList.remove('is-open')
		setTimeout(() => {
			langObj.classList.remove('is-open')
		}, 10)
	}


	// dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu')
	const dropDownMenu   = document.getElementById('js-site-menu')

	dropDownButton.addEventListener('click', function() {
		dropDownButton.classList.toggle('is-close')
		dropDownMenu.classList.toggle('is-active')
	} );


	// dropdown for laptop
	// --------------------------------------------------------------- //

	const dropDownTargets = document.querySelectorAll('.js-dropdown')
	const bgBody = document.querySelector('body');

	for ( let i = 0; i < dropDownTargets.length; i++) {

		dropDownTargets[i].addEventListener('click', function(event) {
			let parent = dropDownTargets[i].closest('.has-dropdown')
			let thisFlag = false

			if ( String(parent.classList['value']).indexOf('is-active') != -1) {
				thisFlag = true
			} else {
				thisFlag = false
			}

			for ( let j = 0; j < dropDownTargets.length; j++) {
				dropDownTargets[j].closest('.has-dropdown').classList.remove('is-active')
				bgBody.classList.remove('is-dropdown-open')
			}


			if ( thisFlag === true ) {
				parent.classList.remove('is-active')
				bgBody.classList.remove('is-dropdown-open')
			} else {
				parent.classList.add('is-active')
				bgBody.classList.add('is-dropdown-open')
			}

			if ( breakpointLaptop.matches ) {
				event.stopPropagation()
				event.preventDefault()
			}
		});
	}



	// lang switcher
	// --------------------------------------------------------------- //

	const langObj = document.getElementById('js-lang-switcher')
	const langTarget = document.getElementById('lang-toggle')
	const langContents = document.getElementById('lang-container')

	if ( langObj ) {
		langTarget.addEventListener('click', () => {
			if ( !langObj.classList.contains('is-open')) {
				langObj.classList.add('is-open')
				langTarget.classList.add('is-open')
				langContents.style.height = 'auto'

				let height = langContents.offsetHeight + 'px'
				langContents.style.height = '0px'

				setTimeout(() => {
					langContents.style.height = height
				}, 0)

			} else {
				langContents.style.height = '0px'
				langTarget.classList.remove('is-open')
				setTimeout(() => {
					langObj.classList.remove('is-open')
				}, 10)
			}
		});
	}


	// page top
	// --------------------------------------------------------------- //

//	function scrollToTop() {
//		var scrolled = getScrolled();
//		window.scrollTo( 0, Math.floor( scrolled / 2 ) );
//		if ( scrolled > 0 ) {
//			window.setTimeout( scrollToTop, 30 );
//		}
//	};
//
//	const pagetopButton   = document.getElementById('js-pagetop')
//
//	pagetopButton.onclick = function() {
//		scrollToTop();
//	};



	// anchor nav
	// --------------------------------------------------------------- //

	const anchorNav = document.getElementById('js-anchor-nav')
	let anchorActivePos = 250;

	if ( anchorNav) {
		window.onscroll = function(e) {
			let offset = window.pageYOffset

			if ( offset > anchorActivePos ) {
				anchorNav.classList.add('is-active')
			} else {
				anchorNav.classList.remove('is-active')
			}

		}
	}



	// search field
	// --------------------------------------------------------------- //

	const seachObj = document.querySelectorAll('.js-search-form')

	for ( let i = 0; i < seachObj.length; i++ ) {

		let searchInput = seachObj[i].querySelector('.js-search-field')
		let searchAlert = seachObj[i].querySelector('.model-search-alert')

		seachObj[i].addEventListener('submit', function(event) {

			let searchInput = seachObj[i].querySelector('.js-search-field')
			let count = searchInput.value.length;

			if ( count < 3 ) {
				searchAlert.classList.add('is-active')
				event.stopPropagation()
				event.preventDefault()
			} else if ( count > 40 ) {
				searchAlert.classList.add('is-active')
				event.stopPropagation()
				event.preventDefault()
			} else {
				searchAlert.classList.remove('is-active')
			}
		})

		searchInput.onblur = function() {
			searchAlert.classList.remove('is-active')
		}

	}



	// footer menu
	// --------------------------------------------------------------- //
	const menuTargets = document.querySelectorAll('.js-footer-menu-toggle')

	for ( let i = 0; i < menuTargets.length; i++ ) {
		let targets = menuTargets[i]
		let content = targets.nextElementSibling

		targets.addEventListener('click', () => {

			if ( !content.classList.contains('is-active') ) {
				targets.classList.add('is-open')
				content.classList.add('is-active')
				content.style.height = 'auto'

				var height = content.clientHeight + 'px'

				content.style.height = '0px'

				setTimeout(() => {
					content.style.height = height
				}, 0)

			} else {
				content.style.height = '0px'
				content.addEventListener('transitionend', () => {
					targets.classList.remove('is-open')
					content.classList.remove('is-active')
				}, {once: true} )
			}


		});
	}



	// tabs
	// --------------------------------------------------------------- //
	// store tabs variable
	const tabsTargets = document.querySelectorAll('.js-tabs-link')

	function tabsFunc(tabsClickEvent) {

		for ( let i = 0; i < tabsTargets.length; i++ ) {
			tabsTargets[i].classList.remove('is-active')
		}

		let clickedTab = tabsClickEvent.currentTarget
		clickedTab.classList.add('is-active')
		tabsClickEvent.preventDefault()

		let tabContentItem = document.querySelectorAll('.tab-content__item')

		for ( let i = 0; i < tabContentItem.length; i++) {
			tabContentItem[i].classList.remove('is-active')
			tabContentItem[i].style.display = 'none';
		}

		let anchorReference = tabsClickEvent.target
		let activeContentId = anchorReference.getAttribute('href')
		let activeContent = document.querySelector(activeContentId)

		fadeIn(document.querySelector(activeContentId), 100);
		activeContent.classList.add('is-active')
	}

	for ( let i = 0; i < tabsTargets.length; i++ ) {
		tabsTargets[i].addEventListener('click', tabsFunc)
	}



	// view mode tab
	// --------------------------------------------------------------- //

	const switchLoop = document.getElementById('js-switch-loop')
	const modeButton = document.querySelectorAll('.mode-button')
	const modeList = document.getElementById('js-mode-list')
	const modePhoto = document.getElementById('js-mode-photo')

	if ( switchLoop ) {
		modeList.addEventListener('click', function() {
			modeList.classList.add('is-active')
			switchLoop.classList.add('has-mode-list')

			modePhoto.classList.remove('is-active')
			switchLoop.classList.remove('has-mode-photo')

			localStorage.setItem('mode', 'list')
		});

		modePhoto.addEventListener('click', function() {
			modePhoto.classList.add('is-active')
			switchLoop.classList.add('has-mode-photo')

			modeList.classList.remove('is-active')
			switchLoop.classList.remove('has-mode-list')

			localStorage.setItem('mode', 'photo')
		});
	}


	// strage
	let modeData = '';
	if ( switchLoop && localStorage.getItem('mode') == 'photo' ) {
		modePhoto.classList.add('is-active')
		modeList.classList.remove('is-active')

		switchLoop.classList.add('has-mode-photo')
		switchLoop.classList.remove('has-mode-list')
	} else if ( switchLoop && localStorage.getItem('mode') == 'list' ) {
		modeList.classList.add('is-active')
		modePhoto.classList.remove('is-active')

		switchLoop.classList.add('has-mode-list')
		switchLoop.classList.remove('has-mode-photo')
	}



	// search filter
	// --------------------------------------------------------------- //

	// variable
	const reset = document.getElementById('js-searh-reset')
	const ckeckFilters = document.querySelectorAll('.js-ckeck-filter')
	const slideTargets = document.querySelectorAll('.js-searh-menu-toggle')
	const slideContents = document.querySelectorAll('.js-toggle-container')


	// reset
	if ( reset ) {
		reset.addEventListener('click', function() {
			for ( let i = 0; i < ckeckFilters.length; i++ ) {
				let parent = ckeckFilters[i].closest('.filter-menu-list__item')
				parent.classList.remove('is-active')
				ckeckFilters[i].checked = false
			}
		});
	}


	// search terms menu ( sp only )
	const searchTarget = document.getElementById('js-searh-toggle')
	const searchContent = document.querySelector('.filter-nav-container')

	if ( searchTarget ) {
		searchTarget.addEventListener('click', () => {
			if ( !searchContent.classList.contains('is-open') ) {
				searchContent.classList.add('is-open')
				searchTarget.classList.add('is-open')
				searchContent.style.height = 'auto'

				let height = searchContent.clientHeight + 'px'
				searchContent.style.height = '0px'
				setTimeout(() => {
					searchContent.style.height = height
				}, 0)
				setTimeout(() => {
					searchContent.style.height = 'auto'
				}, 100)

			} else {
				searchContent.style.height = '0px'
				setTimeout(() => {
					searchContent.classList.remove('is-open')
					searchTarget.classList.remove('is-open')
				}, 200)
			}
		})
	}


	// search more
	const moreTarget = document.getElementById('js-searh-more-toggle')
	const moreContent = document.querySelector('.search-switch.is-more')

	if ( moreTarget ) {
		moreTarget.addEventListener('click', () => {
			if ( !moreContent.classList.contains('is-open') ) {
				moreContent.classList.add('is-open')
				moreTarget.classList.add('is-open')
				moreTarget.querySelector('.toggle-button').classList.add('is-open')
				moreContent.style.height = 'auto'

				let height = moreContent.clientHeight + 'px'
				moreContent.style.height = '0px'
				setTimeout(() => {
					moreContent.style.height = height
				}, 0)

			} else {
				moreContent.style.height = '0px'
				setTimeout(() => {
					moreContent.classList.remove('is-open')
					moreTarget.classList.remove('is-open')
					moreTarget.querySelector('.toggle-button').classList.remove('is-open')
				}, 200)
			}
		})
	}


	// slide accordion
	for ( let i = 0; i < slideTargets.length; i++ ) {
		let parent = slideTargets[i].closest('.js-filter-menu')
		let slideTarget = slideTargets[i].querySelector('.toggle-button')
		let slideContentsTarget = slideContents[i]

		slideTargets[i].addEventListener('click', () => {
			if ( !parent.classList.contains('is-open')) {
				slideContentsTarget.closest('.js-filter-menu').classList.add('is-open')
				slideTarget.classList.add('is-open')
				slideContentsTarget.style.height = 'auto'

				let height = slideContentsTarget.offsetHeight + 'px'
				slideContentsTarget.style.height = '0px'

				setTimeout(() => {
					slideContentsTarget.style.height = height
				}, 0)

			} else {
				slideContentsTarget.style.height = '0px'
				slideTarget.classList.remove('is-open')
				setTimeout(() => {
					slideContentsTarget.closest('.js-filter-menu').classList.remove('is-open')
				}, 200)
				//slideContentsTarget.addEventListener('transitionend', () => {
				//}, {once: true})
			}
		});
	}


	// check active
	for ( let i = 0; i < ckeckFilters.length; i++ ) {
		let target = ckeckFilters[i]
		target.addEventListener('click', () => {
			let parent = target.closest('.filter-menu-list__item')
			if ( target.checked === true ) {
				parent.classList.add('is-active')
			} else {
				parent.classList.remove('is-active')
			}

			checkFloating();
		});
	}


	function checkFloating() {
		let ckeckObj = document.querySelectorAll('.js-ckeck-filter')
		let checkFlag = false;
		const floating = document.getElementById('js-floating-bar');
		for ( let i = 0; i < ckeckObj.length; i++ ) {
			if ( ckeckObj[i].checked === true ) {
				checkFlag = true;
			}
		}
//		floating.classList.add('is-active')
		if ( checkFlag === true ) {
			floating.classList.add('is-active')
		} else {
			floating.classList.remove('is-active')
		}
	}

	function checkFunc() {
		for ( let i = 0; i < ckeckFilters.length; i++ ) {
			let target = ckeckFilters[i]
			let parent = target.closest('.filter-menu-list__item')
			if ( target.checked === true ) {
				parent.classList.add('is-active')
			} else {
				parent.classList.remove('is-active')
			}
		}
	}

	checkFunc();



	// term filter
	// --------------------------------------------------------------- //

	const termSlideTargets = document.querySelectorAll('.js-term-menu-toggle')
	const termSlideContent = document.querySelectorAll('.js-term-toggle-container')

	for ( let i = 0; i < termSlideTargets.length; i++ ) {
		let parent = termSlideTargets[i].closest('.js-term-menu')
		let slideTarget = termSlideTargets[i].querySelector('.toggle-button')
		let slideContentsTarget = termSlideContent[i]

		termSlideTargets[i].addEventListener('click', () => {
			if ( !parent.classList.contains('is-open')) {
				slideContentsTarget.closest('.js-term-menu').classList.add('is-open')
				slideTarget.classList.add('is-open')
				slideContentsTarget.style.height = 'auto'

				let height = slideContentsTarget.offsetHeight + 'px'
				slideContentsTarget.style.height = '0px'

				setTimeout(() => {
					slideContentsTarget.style.height = height
				}, 0)

			} else {
				slideContentsTarget.style.height = '0px'
				slideTarget.classList.remove('is-open')
				setTimeout(() => {
					slideContentsTarget.closest('.js-term-menu').classList.remove('is-open')
				}, 200)
				//slideContentsTarget.addEventListener('transitionend', () => {
				//}, {once: true})
			}
		});
	}




	// products top lineup
	// --------------------------------------------------------------- //
	const lineupNav = document.querySelectorAll('.js-lineup-nav')
	const lineupContents = document.querySelectorAll('.top-lineup-item')

	for ( let i = 0; i < lineupNav.length; i++ ) {
		let targets = lineupNav[i]

		targets.addEventListener('click', () => {
			let dataTarget = targets.dataset.target
			let contents = document.getElementById(dataTarget)

			for ( let j = 0; j < lineupContents.length; j++ ) {
				lineupContents[j].classList.remove('is-active')
			}

			contents.classList.add('is-active')


//			if ( breakpointLarge.matches ) {
//				e.preventDefault()
//				return false;
//			}

		});
	}




	// faq toggle
	// --------------------------------------------------------------- //
	const faqSlideTargets = document.querySelectorAll('.js-faq-toggle')
	const faqSlideContent = document.querySelectorAll('.js-faq-toggle-container')

	for ( let i = 0; i < faqSlideTargets.length; i++ ) {
		let parent = faqSlideTargets[i].closest('.js-faq-item')
		let slideTarget = faqSlideTargets[i].querySelector('.toggle-button')
		let slideContentsTarget = faqSlideContent[i]

		faqSlideTargets[i].addEventListener('click', () => {
			if ( !parent.classList.contains('is-open')) {
				slideContentsTarget.closest('.js-faq-item').classList.add('is-open')
				slideTarget.classList.add('is-open')
				slideContentsTarget.style.height = 'auto'

				var height = slideContentsTarget.outerHeight + 'px'

				//slideContentsTarget.style.height = '0px'

				setTimeout(() => {
					slideContentsTarget.style.height = height
				}, 0)

			} else {
				slideContentsTarget.style.height = '0px'
					slideContentsTarget.closest('.js-faq-item').classList.remove('is-open')
					slideTarget.classList.remove('is-open')
			}
		});
	}



	// [関数] fade in
	// --------------------------------------------------------------- //
	function fadeIn($node, $duration) {
		if ( getComputedStyle($node).display !== 'none' ) {
			return
		}

		if ($node.style.display === 'none') {
			$node.style.display = ''
		} else {
			$node.style.display = 'block'
		}
		$node.style.opacity = 0

		let start = performance.now()

		requestAnimationFrame( function tick(timestamp) {
			let easing = (timestamp - start) / $duration

			$node.style.opacity = Math.min(easing, 1)

			if (easing < 1) {
				requestAnimationFrame(tick)
			} else {
				$node.style.opacity = ''
			}
		});
	}



	// [plugin] ScrollSpy
	// --------------------------------------------------------------- //

	const anchorContents = document.getElementById('js-scroll-spy');
	if ( anchorContents ) {
		var spy = new ScrollSpy(anchorContents, {
			nav: '#js-anchor-nav-list > li > a',
			className: 'is-active',
			callback: function () {
			}
		});
	}



	// [plugin] lightGallery
	// --------------------------------------------------------------- //

	let gallery = document.getElementById('js-gallery');

	if ( gallery ) {
		lightGallery( gallery, {
			selector: '.js-gallery-item',
		});
	}

} );



// switch list scroll lock
// --------------------------------------------------------------- //
window.onload = function() {

	if ( document.getElementById('js-switch-loop-header') ) {

		let heightTarget = document.getElementById('js-switch-loop-header')

		let heightTargetPost = heightTarget.getBoundingClientRect().top
		let startPost = heightTargetPost + window.pageYOffset
		let contentHeight = document.getElementById('js-switch-loop').offsetHeight
		let endPost = heightTargetPost + window.pageYOffset + contentHeight - heightTarget.offsetHeight

		// モード変わった時に高さを計算し直す
		document.getElementById('js-mode-list').addEventListener('click', function() {
			heightTarget = document.getElementById('js-switch-loop-header')
			heightTargetPost = heightTarget.getBoundingClientRect().top
			startPost = heightTargetPost + window.pageYOffset
			contentHeight = document.getElementById('js-switch-loop').offsetHeight
			endPost = heightTargetPost + window.pageYOffset + contentHeight - heightTarget.offsetHeight
		} );



		window.onscroll = function(e) {
			let offset = window.pageYOffset

			if ( offset > startPost && offset < endPost ) {
				heightTarget.classList.add('is-fixed')
				heightTarget.classList.remove('is-absolute')
			} else if ( offset > endPost  ) {
				heightTarget.classList.add('is-absolute')
			} else {
				heightTarget.classList.remove('is-fixed')
				heightTarget.classList.remove('is-absolute')
			}

		}
	}

};

